import React from 'react';
import { useParams } from 'react-router-dom';
import { isLocalePrefix } from 'utils/localePath';
import DefaultLayout from 'layouts/defaultLayout';
import NotFound from 'pages/notfound';

const LocaleLayout = () => {
  const { locale } = useParams();

  if (!isLocalePrefix(locale)) {
    return <NotFound />;
  }

  return <DefaultLayout />;
};

export default LocaleLayout;
